import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../common';
import { CustomerProfilesApiClient } from './customer-profiles.api.client';
import { CustomerProfilesInMemoryApiClient } from './customer-profiles.api.inmemory.client';
import { ICustomerProfilesApiClient } from './i-customer-profiles-api.client';

@Injectable({
  providedIn: 'root'
})
export class CustomerProfilesApiClientProvider extends ApiClientProvider<ICustomerProfilesApiClient> {
  constructor(
    private client: CustomerProfilesApiClient,
    private inMemoryClient: CustomerProfilesInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): ICustomerProfilesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): ICustomerProfilesApiClient {
    return this.client;
  }
}
